export default "__VITE_ASSET__Cy4qVDGf__"